import { Slider } from '@staccx/bento'
import { useEffect, useState } from 'react'

export function CarImage({
  vehicleType,
  budgetNo,
  shouldAnimate,
  carImageQuery,
}: {
  vehicleType: string
  budgetNo?: string
  shouldAnimate: boolean
  carImageQuery?: any
}) {
  const [arrayNumber, setArrayNumber] = useState(0)
  const [fadeKey, setFadeKey] = useState(0)
  useEffect(() => {
    if (!shouldAnimate) return
    setFadeKey((prev) => prev + 1)
  }, [arrayNumber])
  useEffect(() => {
    if (!shouldAnimate) return
    if (!carImageQuery.data || carImageQuery.data.length === 0) return

    const interval = setInterval(() => {
      setArrayNumber((prev) => {
        const next = prev + 1
        return next >= carImageQuery.data.length ? 0 : next
      })
    }, 3000)

    return () => clearInterval(interval)
  }, [carImageQuery.data])

  if (carImageQuery.isLoading) return null
  if (carImageQuery.isError) {
    return (
      <div className="flex w-full flex-col gap-8 items-center justify-center md:min-h-[330px]">
        <img
          src="/placeholder.png"
          className=" z-[1] top-52 md:left-44 overflow-visible"
        />
      </div>
    )
  }
  if (carImageQuery?.data?.length === 0) {
    return (
      <div className="flex w-full flex-col gap-8 items-center justify-center md:min-h-[330px]">
        <img
          src="/placeholder.png"
          className=" z-[1] top-52 md:left-44 overflow-visible"
        />
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col gap-8 items-center justify-center md:min-h-[330px]">
      <img
        key={fadeKey}
        className="  object-cover transition-opacity duration-5000  fade-in"
        width={450}
        src={carImageQuery.data[shouldAnimate ? arrayNumber : 0]}
      />
    </div>
  )
}

export function carImageFallback(vehicleType: string) {
  switch (vehicleType) {
    case 'Sedan':
      return '/volkswagen.png'
    case 'SUV':
      return '/suv.png'
    case 'Van':
      return '/van.png'
    case 'Truck':
      return '/truck.png'
    case 'Cabriolet':
      return '/cabriolet.png'
    case 'Coupe':
      return '/coupe.png'
    case 'Hatchback':
      return '/hatchback.png'
    case 'StationWagon':
      return '/stationwagon.png'
    case 'MPV':
      return '/mpv.png'
    case 'Pickup':
      return '/pickup.png'
    default:
      return '/car.png'
  }
}
